import type { RootState } from '../configureStore';
import {
  initialOrderFlagsState,
  type OrderFlagScope,
  type OrderFlagsState,
} from '../reducers/orderFlags';

// `RootState` sale parcial por redux-persist: antes de rehidratar (o con un
// trozo ilegible) la clave puede faltar, así que se cae al estado inicial.
const getSlice = (state: RootState): OrderFlagsState =>
  state.orderFlags ?? initialOrderFlagsState;

/** Lo pendiente manda; si no hay, lo que dice el servidor. */
export const selectIsOrderFlagged =
  (orderId: string) =>
  (state: RootState): boolean => {
    const slice = getSlice(state);
    return slice.pending[orderId]?.flagged ?? orderId in slice.byOrderId;
  };

export const selectOrderFlagsOwnerKey = (state: RootState) =>
  getSlice(state).ownerKey;

export const selectOrderFlagsLoadedAt = (state: RootState) =>
  getSlice(state).loadedAt;

/** Órdenes que el servidor dio por marcadas (sin lo pendiente). */
export const selectConfirmedFlaggedOrderIds = (state: RootState): string[] =>
  Object.keys(getSlice(state).byOrderId);

/** Ámbito confirmado (persona o grupo); `null` si aún no se conoce. */
export const selectOrderFlagScope = (state: RootState): OrderFlagScope | null =>
  getSlice(state).scope ?? null;

export const selectOrderFlagScopeCheckedAt = (
  state: RootState
): number | null => getSlice(state).scopeCheckedAt ?? null;

/** Nombre del grupo si las marcas son de grupo; `null` si son personales. */
export const selectOrderFlagsGroupName = (state: RootState): string | null => {
  const scope = selectOrderFlagScope(state);
  return scope?.kind === 'GROUP' ? scope.groupName ?? null : null;
};
